<section class="snapshot-tab" aria-label="Flujos">
  <app-snapshot-state *ngIf="envelopeState; else withResult" [state]="envelopeState" (retry)="retry()"></app-snapshot-state>

  <ng-template #withResult>
    <article class="alg-card">
      <header class="alg-card__header">
        <span class="alg-card__icon"><i class="fa-solid fa-money-bill-transfer" aria-hidden="true"></i></span>
        <div class="alg-card__titles">
          <h2>Flujos del cliente</h2>
          <p data-test="flows-label">
            <strong>Flujo por CFDI (cobrado y pagado según facturas), no saldos bancarios</strong
            ><ng-container *ngIf="flows?.window as window"> · {{ month(window.from) }} a {{ month(window.to) }}</ng-container>
          </p>
        </div>
        <span class="alg-pill is-neutral" *ngIf="view?.snapshot?.viewedRevision" data-test="snapshot-revision"
          >Foto · revisión {{ view?.snapshot?.viewedRevision }}</span
        >
      </header>

      <p class="alg-notice is-neutral" *ngIf="shortWindow" data-test="flows-short-window">
        <i class="fa-solid fa-hourglass-half" aria-hidden="true"></i>
        <span
          >Solo hay {{ rows.length }} {{ rows.length === 1 ? 'mes' : 'meses' }} con flujo: menos de un año. La calculadora lo toma como dato
          parcial.</span
        >
      </p>
      <p class="alg-notice is-neutral" *ngIf="rows.length && !hasRent" data-test="flows-no-rent">
        <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
        <span>Sin renta de referencia (no hay oferta ni cotización): no se mide cuántas veces el flujo cubre la renta.</span>
      </p>

      <div class="alg-card__body">
        <app-snapshot-state *ngIf="!rows.length; else withFlows" [compact]="true" state="unavailable"></app-snapshot-state>

        <ng-template #withFlows>
          <div class="alg-kpis" data-test="flows-kpis">
            <div class="alg-kpi" *ngFor="let average of averages; trackBy: trackByIndex" [attr.data-test]="'flows-' + average.key">
              <span class="alg-kpi__label">{{ average.label }}</span>
              <ng-container *ngIf="flows?.averages?.[average.key] as value; else noAverage">
                <span class="alg-kpi__value" [class.is-bad]="value.net < 0" [attr.title]="pesos(value.net)">{{ compact(value.net) }}</span>
                <span class="alg-kpi__sub">entra {{ compact(value.inflow) }} · sale {{ compact(value.outflow) }}</span>
              </ng-container>
              <ng-template #noAverage><span class="alg-kpi__value">—</span></ng-template>
            </div>
            <div class="alg-kpi" data-test="flows-rent-coverage">
              <span class="alg-kpi__label">Flujo neto 12 meses / renta anual</span>
              <span class="alg-kpi__value" [class.is-bad]="(flows?.rentCoverage?.netToRent12m ?? 0) < 1 && hasRent">{{
                hasRent ? coverage(flows?.rentCoverage?.netToRent12m) : '—'
              }}</span>
              <span class="alg-kpi__sub" *ngIf="flows?.rentCoverage as rent"
                >renta {{ hasRent ? pesos(rent.monthlyRent) : '—' }} · {{ rentSources[rent.rentSource] }}</span
              >
            </div>
          </div>

          <div class="alg-box chart-box" data-test="flows-chart">
            <div class="alg-sec">
              <h3>Flujo mensual</h3>
              <span class="chart-legend"
                ><span><i class="legend-dot is-in" aria-hidden="true"></i>Entradas</span
                ><span><i class="legend-dot is-out" aria-hidden="true"></i>Salidas</span></span
              >
            </div>
            <div
              class="chart-bars"
              role="img"
              [attr.aria-label]="'Flujo mensual de ' + month(flows?.window?.from) + ' a ' + month(flows?.window?.to)"
            >
              <span class="chart-pair" *ngFor="let item of bars; trackBy: trackByIndex">
                <span class="chart-bar is-in" [style.height.px]="item.inflow" [attr.title]="month(item.month) + ' · entradas'"></span>
                <span class="chart-bar is-out" [style.height.px]="item.outflow" [attr.title]="month(item.month) + ' · salidas'"></span>
              </span>
            </div>
            <div class="chart-axis" aria-hidden="true">
              <span>{{ month(flows?.window?.from) }}</span
              ><span>{{ month(flows?.window?.to) }}</span>
            </div>
          </div>

          <div class="alg-table-wrap is-tall">
            <table class="alg-table flows-table" data-test="flows-table">
              <caption class="p-hidden-accessible">
                Flujo mensual por CFDI: entradas, salidas, neto y acumulado
              </caption>
              <thead>
                <tr>
                  <th scope="col">Mes</th>
                  <th scope="col" class="is-num">Entradas</th>
                  <th scope="col" class="is-num">Salidas</th>
                  <th scope="col" class="is-num">Neto</th>
                  <th scope="col" class="is-num">Acumulado</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of rows; trackBy: trackByIndex" data-test="flows-row">
                  <td>{{ month(row.month) }}</td>
                  <td class="is-num">{{ pesos(row.inflow) }}</td>
                  <td class="is-num">{{ pesos(row.outflow) }}</td>
                  <td class="is-num" [class.is-bad]="row.net < 0">{{ pesos(row.net) }}</td>
                  <td class="is-num" [class.is-bad]="row.cumulative < 0">{{ pesos(row.cumulative) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-template>

        <!-- El flujo del obligado solidario no se replica: no tiene RFC ni CIEC (plan v4.2 §8b). -->
        <p class="alg-notice is-neutral guarantor-note" data-test="flows-guarantor">
          <i class="fa-solid fa-user-shield" aria-hidden="true"></i>
          <span
            >El flujo del obligado solidario no se calcula aquí: no tiene RFC ni CIEC en la plataforma. Si el arrendamiento tiene el Excel
            de «Análisis de riesgo» importado, está ahí.</span
          >
        </p>
      </div>
    </article>
  </ng-template>
</section>
